// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ExperimentStore from "./ExperimentStore.bs.js";
import * as Experiment_Utils from "./Experiment_Utils.bs.js";

function pxToRem(pxValue) {
  return (pxValue / 16).toString() + "rem";
}

function make(param) {
  var statusColor = param.color;
  return React.createElement("div", {
              id: param.id,
              style: {
                color: statusColor,
                cursor: "default",
                display: "flex",
                fontWeight: "600",
                marginTop: pxToRem(8),
                marginBottom: pxToRem(8),
                alignItems: "center"
              }
            }, React.createElement("span", {
                  style: {
                    backgroundColor: statusColor,
                    height: pxToRem(8),
                    marginRight: pxToRem(4),
                    width: pxToRem(8),
                    borderRadius: "50%"
                  }
                }), param.text);
}

var ExperimentMenu$Status = make;

function Make(T) {
  var ExperimentMenu$Status$Make = function (props) {
    var status = props.status;
    return make({
                id: props.id,
                text: Curry._1(T.statusToJs, status),
                color: Curry._1(T.getStatusColor, status)
              });
  };
  return {
          make: ExperimentMenu$Status$Make
        };
}

var Status = {
  make: ExperimentMenu$Status,
  Make: Make
};

function getStatusColor(status) {
  if (status === "WorkInProgress") {
    return "#E53544";
  } else if (status === "Done") {
    return "#0AB97C";
  } else if (status === "ReadyForQA") {
    return "#2f80ed";
  } else {
    return "#F2994A";
  }
}

function ExperimentMenu$Status$Make(props) {
  var status = props.status;
  return make({
              id: props.id,
              text: ExperimentStore.experimentStatusToJs(status),
              color: getStatusColor(status)
            });
}

var ExperimentStatus = {
  make: ExperimentMenu$Status$Make
};

function MakeExperimentMenu(Store) {
  var ExperimentMenu$MakeExperimentMenu = function (props) {
    var forceVisible = props.forceVisible;
    var forceVisible$1 = forceVisible !== undefined ? forceVisible : false;
    var match = React.useReducer((function (state, action) {
            if (action) {
              Curry._2(Store.selectExperiment, action._0, action._1);
              return {
                      visible: state.visible,
                      hasChosen: true
                    };
            } else {
              return {
                      visible: !state.visible,
                      hasChosen: state.hasChosen
                    };
            }
          }), {
          visible: false,
          hasChosen: false
        });
    var dispatch = match[1];
    var state = match[0];
    var handleKeyDown = function ($$event) {
      if ($$event.ctrlKey && $$event.shiftKey && ($$event.key === "K" || $$event.key === "k")) {
        return Curry._1(dispatch, /* ToggleMenuBar */0);
      }
      
    };
    React.useEffect((function () {
            var shouldBeVisible = Belt_Option.getWithDefault(Belt_Option.map(Belt_List.getBy(Experiment_Utils.QueryString.getAllQueryParams(undefined), (function (item) {
                            return Js_string.includes("showexperiments", item[0].toLowerCase());
                          })), (function (item) {
                        return item[1] === "true";
                      })), false);
            if (shouldBeVisible) {
              Curry._1(dispatch, /* ToggleMenuBar */0);
            }
            
          }), []);
    React.useEffect((function () {
            document.addEventListener("keydown", handleKeyDown);
            return (function (param) {
                      document.removeEventListener("keydown", handleKeyDown);
                    });
          }), []);
    return React.createElement("div", {
                "aria-hidden": true,
                style: {
                  backgroundColor: "#ffffff",
                  height: "100%",
                  position: "fixed",
                  right: "0px",
                  top: "0px",
                  width: pxToRem(248),
                  zIndex: "2000",
                  opacity: state.visible || forceVisible$1 ? "1" : "0",
                  boxShadow: "-1px 0 1px 0 #CCCCCC",
                  transition: "transform 250ms cubic-bezier(0, 0.35, 0.35, 1) 0ms, opacity 200ms ease 100ms",
                  transform: state.visible || forceVisible$1 ? "translateX(0%)" : "translateX(100%)"
                }
              }, React.createElement("div", {
                    style: {
                      fontFamily: "BentonSansRegular",
                      fontSize: pxToRem(14),
                      height: "100vh",
                      overflow: "scroll",
                      paddingTop: pxToRem(8),
                      paddingLeft: pxToRem(8)
                    }
                  }, React.createElement("h2", {
                        style: {
                          fontSize: pxToRem(16),
                          marginBottom: pxToRem(8)
                        }
                      }, "A/Binks Feature Testing"), state.hasChosen ? React.createElement("p", {
                          style: {
                            color: "#C29B40",
                            margin: pxToRem(16)
                          }
                        }, "Refresh the page for the changes to take affect.") : React.createElement("div", undefined, Belt_List.toArray(Belt_List.map(Curry._1(Store.getExperiments, undefined), (function (experiment) {
                                    return React.createElement("div", {
                                                key: experiment.id,
                                                style: {
                                                  marginBottom: pxToRem(16)
                                                }
                                              }, React.createElement("p", {
                                                    style: {
                                                      fontWeight: "600"
                                                    }
                                                  }, experiment.name), React.createElement(ExperimentMenu$Status$Make, {
                                                    id: "experimentStatus",
                                                    status: experiment.status
                                                  }), Belt_List.toArray(Belt_List.map(experiment.groupDistribution, (function (group) {
                                                          return React.createElement("div", {
                                                                      key: group[0],
                                                                      style: {
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                      }
                                                                    }, React.createElement("input", {
                                                                          style: {
                                                                            height: pxToRem(18),
                                                                            margin: "0px",
                                                                            position: "relative",
                                                                            width: pxToRem(18)
                                                                          },
                                                                          tabIndex: -1,
                                                                          checked: experiment.group.contents === group[0],
                                                                          name: "radio_" + experiment.id,
                                                                          type: "radio",
                                                                          onChange: (function (param) {
                                                                              Curry._1(dispatch, /* ToggleHasChosen */{
                                                                                    _0: experiment.id,
                                                                                    _1: group[0]
                                                                                  });
                                                                            })
                                                                        }), React.createElement("p", {
                                                                          style: {
                                                                            marginLeft: pxToRem(8)
                                                                          }
                                                                        }, group[0]));
                                                        }))));
                                  }))))));
  };
  return {
          make: ExperimentMenu$MakeExperimentMenu
        };
}

var baseFontSize = 16;

export {
  baseFontSize ,
  pxToRem ,
  Status ,
  ExperimentStatus ,
  MakeExperimentMenu ,
}
/* react Not a pure module */
